import httpUtil from "@/utils/httpUtil";

export const selectBranchList = params => httpUtil.get("/storeBranches", params);
export const addBranch = params => httpUtil.post("/storeBranches", params);
export const updateBranch = params => httpUtil.post("/storeBranches/update", params);
export const delBranch = params => httpUtil.delete(`/storeBranches/delete/${params}`);


